module.exports = __webpack_public_path__ + "static/media/img-bg1.6c883c86.png";